export const INITIAL_VALUES = {
  curp: "",
  selfie: "",
};
